import axios from "axios";

// Base URLs come from .env (REACT_APP_*), with production defaults as fallback.
const PHP_BASE =
    process.env.REACT_APP_API_PHP_BASE_URL || "https://api-php.mahabharatanubhavkendra.com/";
const PY_BASE =
    process.env.REACT_APP_API_PY_BASE_URL || "https://api-py.mahabharatanubhavkendra.com/";

const trimSlash = (url) => url.replace(/\/+$/, "");

export const apiAxios = axios.create({
    baseURL: `${trimSlash(PHP_BASE)}/api/`,
});

export const bookingApi = axios.create({
    baseURL: `${trimSlash(PHP_BASE)}/users/`,
});

export const apiPyAxios = axios.create({
    baseURL: `${trimSlash(PY_BASE)}/api/`,
});
